import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  attachmentsByPatientListLoading: false,
  tripsByPatientListLoading: false,
  patientsList: [],
  tripsByPatientList: [],
  attachmentsByPatientList: [],
  patientPayment: ''
};
const patientsReducer = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    setTripsByPatientListLoading(state, action) {
      return {
        ...state,
        tripsByPatientListLoading: action.payload
      };
    },
    setAttachmentsByPatientListLoading(state, action) {
      return {
        ...state,
        attachmentsByPatientListLoading: action.payload
      };
    },
    getPatientsList(state, action) {
      let newList;
      if (action.payload?.data?.data) {
        newList = action.payload?.data?.data.map((item) => {
          return {
            ...item,
            email: item?.email,
            addressLine: item?.address?.line,
            addressZip: item?.address?.zipCode,
            addressCity: item?.address?.city,
            addressState: item?.address?.state,
            payor: item?.payor?.name,
            mailingAddressLine: item?.mailingAddress?.line,
            mailingAddressCity: item?.mailingAddress?.city,
            mailingAddressState: item?.mailingAddress?.state,
            mailingAddressZip: item?.mailingAddress?.zipCode,
            createdBy: item?.createdBy?.userName
          };
        });
      }

      return {
        ...state,
        patientsList: newList,
        count: action.payload?.data?.count
      };
    },
    getPatientsFilterList(state, action) {
      let newList;
      if (action.payload?.result) {
        newList = action.payload?.result.map((item) => {
          return {
            ...item,
            email: item?.email,
            addressLine: item?.address?.line,
            addressZip: item?.address?.zipCode,
            addressCity: item?.address?.city,
            addressState: item?.address?.state,
            payor: item?.payor?.name,
            mailingAddressLine: item?.mailingAddress?.line,
            mailingAddressCity: item?.mailingAddress?.city,
            mailingAddressState: item?.mailingAddress?.state,
            mailingAddressZip: item?.mailingAddress?.zipCode,
            createdBy: item?.createdBy?.userName
          };
        });
      }

      return {
        ...state,
        patientsList: newList,
        count: action.payload?.count
      };
    },
    getPatientById(state, action) {
      return {
        ...state,
        patientInfo: action.payload?.data
      };
    },
    getPatientPayment(state, action) {
      return {
        ...state,
        patientPayment: action.payload?.data
      };
    },
    getAttachmentsByPatientList(state, action) {
      return {
        ...state,
        attachmentsByPatientList: action.payload?.data?.result,
        attachmentsByPatientListCount: action.payload?.data?.count
      };
    },
    getTripsByPatientList(state, action) {
      return {
        ...state,
        tripsByPatientList: action.payload?.data?.result,
        tripsByPatientListCount: action.payload?.data?.count
      };
    }
  }
});

export default patientsReducer.reducer;

export const patientsActions = patientsReducer.actions;

export const createPatient = (role) => async () => {
  try {
    const res = await api.post(`api/Patient`, role);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const editPatient = (data, id) => async () => {
  try {
    const res = await api.put(`api/Patient/${id}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const getPatientsAction = (data) => async (dispatch) => {
  dispatch(patientsActions.setLoading(true));
  try {
    const res = await api.get(`api/Patient`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(patientsActions.getPatientsList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(patientsActions.setLoading(false));
  }
};
export const getPatientsFilterAction = (data) => async (dispatch) => {
  dispatch(patientsActions.setLoading(true));
  try {
    const res = await api.post(`api/Patient/filter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(patientsActions.getPatientsFilterList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(patientsActions.setLoading(false));
  }
};
export const getPatientById = (id) => async (dispatch) => {
  dispatch(patientsActions.setLoading(true));
  try {
    const res = await api.get(`api/Patient/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(patientsActions.getPatientById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(patientsActions.setLoading(false));
  }
};
export const clearPatientById = () => async (dispatch) => {
  dispatch(patientsActions.getPatientById(''));
};
export const removePatientAction =
  (id, setRemoveDialog) => async (dispatch) => {
    try {
      const res = await api.delete(`api/Patient/${id}`);
      if (res.status === 200 && res?.data) {
        setRemoveDialog('');
        toast.success('Removed successfully!!!');
        return Promise.resolve(res?.data);
      }
    } catch (errors) {
      formErrorsHandle(errors.response?.data, []);
      return Promise.reject(errors.response?.data);
    }
  };

export const getTripsByPatientAction = (data, id) => async (dispatch) => {
  dispatch(patientsActions.setTripsByPatientListLoading(true));
  try {
    const res = await api.post(`api/Patient/FilterTrips/${id}`, data);
    if (res.status === 200 && res?.data) {
      dispatch(patientsActions.getTripsByPatientList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(patientsActions.setTripsByPatientListLoading(false));
  }
};

export const getAttachmentsByPatientAction = (data, id) => async (dispatch) => {
  dispatch(patientsActions.setAttachmentsByPatientListLoading(true));
  try {
    const res = await api.post(`api/Patient/Attachments/${id}`, data);
    if (res.status === 200 && res?.data) {
      dispatch(patientsActions.getAttachmentsByPatientList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(patientsActions.setAttachmentsByPatientListLoading(false));
  }
};
export const createPatientPayment = (id, data) => async () => {
  try {
    const res = await api.post(`api/PaymentMethod/Patient${id}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const getPatientPayment = (id) => async (dispatch) => {
  try {
    const res = await api.get(`api/PaymentMethod/Patient${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(patientsActions.getPatientPayment(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const removePatientPayment = (id) => async () => {
  try {
    const res = await api.delete(`api/PaymentMethod/Patient/${id}`);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
